<template>
  <div>
    <div class="main">
      <div id="container">
        <div class="row">
          <div class="col-xs-12">
            <div class="content">
              <p class="little-title">{{ $t('aboutUs') }}</p>
              <p>{{ $t('company') }}</p>
              <p>{{ $t('concentrate') }}</p>
              <p>{{ $t('wish') }}</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="contact-us">
              <p class="little-title">{{ $t('contactUs') }}</p>
              <p>{{ $t('email') }} &nbsp;iplexservice@gmail.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import locales from './lang'

  export default {
    name: 'about-us',
    locales
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";

  .main {
    width: 100%;
    background-color: #edf2f6;
    line-height: .36rem;
  }

  #container {
    width: 100%;
    max-width: 1140px;
    margin: auto;
    color: $gray-darker;
    padding: .24rem .15rem;
    min-height: calc(100vh - .55rem - 3.3rem);
    @media (min-width: 768px) {
      width: 60%;
      padding: .24rem 0 1.5rem 0;
    }
  }

  p {
    margin: 0;
    padding: 0;
    font-size: .14rem;
    line-height: .36rem;
  }

  p.little-title {
    font-size: .2rem;
    margin-top: .36rem;
  }
</style>



// WEBPACK FOOTER //
// AboutUs.vue?bf27fc9c